import * as THREE from 'three';
import { gsap } from 'gsap';

import Project from  "../Project.js"; 

let animationPaused;
const animationActionClips = [];
export default class Asset3D {
	constructor() {
		console.log( "Asset3D" );
		this.project = new Project(); // create ref to the project class 
		this.zappar = this.project.zappar; // create ref to Zappar in the project file
		this.world = this.project.world;  // create ref to the world in the project file
		this.resources = this.project.resources; // create ref to the resources in the project file
		this.time = this.project.time; // create a ref to the time class ( need to update animtion mixer on every frame )
        
		this.resource = this.resources.items.assets3D; // glb
		this.resourceAnimation = this.resource.animations; // create a ref for accessing any animations stored in the glb file

		// Check to see if asset has exported animations
		this.hasAnimation = this.resourceAnimation.length > 0 ? true : false; 
		
		this.setModel();

		this.setAnimation();
	}
	setInstance() {
	}
	setModel() {
		this.model = this.resource.scene; // create a ref to all meshes in the glb file glb file
		
		this.mesh1 = this.model.getObjectByName("PineTree1");
		// Look through all of the model
		this.allSceneObjects = [];
		this.sceneModels = [this.model.getObjectByName("PineTree2")]
		this.model.traverse( ( child ) => {
			this.allSceneObjects.push(child);
			if ( child.isMesh) { 
				// If child is a mesh then ensure that the meshes cast shadows.
				child.castShadow = true; 
				child.receiveShadow = true;
				child.material.vertexColors = false;
				this.allSceneObjects.push(child);
				this.sceneModels.push(child)
				// set correct texture encording for all imported textures in the model
				//child.material.map.encoding = THREE.sRGBEncoding;
			}
		} );
		for (let i = 0; i < this.sceneModels.length; i++)
		{
					
			this.sceneModels[i].position.set (0,0,0);
				//console.log(child);
				//this.sceneModels[i].visible = true;
				if (this.sceneModels[i] != this.mesh1){	
					console.log('position.set')
					console.log(typeof this.sceneModels[i].position.set)			
					this.sceneModels[i].visible = false;
					this.sceneModels[i].position.set (1000,0,0);
				}
			}
			
			console.log(this.sceneModels);
		// Positions
		//mesh2.visible = true;
		
		this.model.scale.set( 1, 1, 1 );
		this.model.getObjectByName("PineTree1").visible = false;
		
		// Need to add the model to the instantTrackerGroup for it to be display
		this.zappar.instantTrackerGroup.add( this.model );
	}
	
	setAnimation() {
		if( !this.hasAnimation ) return; // if the model has no animation do nothing

		this.animMixer = new THREE.AnimationMixer( this.model );
		// Set up Subclips
		this.resourceAnimation.forEach( ( element ) => {
			// Subclips consit of a name, start frame, end frame
			// Useuful if all animations are on one exported timeline
			const firstClip = this.animMixer.clipAction( THREE.AnimationUtils.subclip( element, "firstAction", 255, 2510 ) );
			// Push each clip to a array so we can access them more easily
			animationActionClips.push( firstClip );
		} );
		// Listener for when a animation clip finishes
		this.animMixer.addEventListener( "finished", ( e ) => {
            
		} );
	}
	IntroAnimation(){
		gsap.to(this.model.scale, {x:1, Y: 1, Z:1});
	}
	
	treeGrowManager(StateMachineId){
		this.pineTree1 = this.model.getObjectByName("PineTree1");
		this.pineTree2 = this.model.getObjectByName("PineTree2");
		this.pineTree3 = this.model.getObjectByName("PineTree3");
		this.pineTree4 = this.model.getObjectByName("PineTree4");
		this.pineTree5 = this.model.getObjectByName("PineTree5");
		this.growTL = gsap.timeline();

		this.growTL.to( this.pineTree2.scale, {
			y :1, 
			duration : 0 })
			
		this.growTL.to( this.pineTree3.scale, {
			z :0.006, 
			duration : 0 })
			
		this.growTL.to( this.pineTree4.scale, {
			z :0.004, 
			duration : 0 })
			
		this.growTL.to( this.pineTree5.scale, {
			z :.5, 
			duration : 0 })
		//grow stage 1
		switch(StateMachineId){
			case 1:
			this.createTrees(this.pineTree1, this.pineTree2, 3. ,"Y");
				break;
			case 2:
			this.createTrees(this.pineTree2, this.pineTree3);
				break;
			case 3:
			this.createTrees(this.pineTree3, this.pineTree4, 3, "Z");
				break;
			case 4:
			this.createTrees(this.pineTree4, this.pineTree5, 3, "Z");
				break;
		}

	}
	createTrees(smallTree, largeTree, multiplier, axis) {
        this.smallTree = smallTree;
        this.largeTree = largeTree;
		
        //this.smallTree.position.set( 0, 0, 0 );
		//this.largeTree.position.set( 0, 0, 0 );
        //this.largeTree.rotation.set( 3, 0, 0 );
        //this.smallTree.rotation.set( 3, 0, 0 );
		this.treeGrow(multiplier,axis)
    }
    treeGrow(multiplier, axis) {
		this.wateringCanAnim();
        this.growTreeTL = gsap.timeline();
		if(axis === "Y"){
        this.growTreeTL.to( this.smallTree.scale, {
            y :multiplier, 
            duration : 5 
        }, 0 );}
		else if(axis === "Z"){this.growTreeTL.to( this.smallTree.scale, {
            z :multiplier, 
            duration : 5 
        }, 0 );}
        this.growTreeTL.add( ()=>{
			this.smallTree.position.set(1000,0,0);
			console.log(this.largeTree);
			this.largeTree.position.x = 0;
			console.log(this.largeTree);

			//this.largeTree.position.set(0,0,0);
            this.smallTree.visible = false;
            this.largeTree.visible = true;
			this.argh();
			
        }, 4.5 );
    }
	lavenderGrow(stage){
		this.lavender1 = this.model.getObjectByName("Lavender1");
		this.lavender2 = this.model.getObjectByName("Lavender2");
		this.lavender3 = this.model.getObjectByName("Lavender3");
		this.lavender4 = this.model.getObjectByName("Lavender4");
		this.stage = stage;
		
		switch(this.stage){
			case 1:
				this.wateringCanAnim();
				this.grow(this.lavender1, 2);
				this.growTL.to( this.lavender4.scale, {
					z :1, 
					duration : 0 })

				break;
				
			case 2:
				this.wateringCanAnim();
				
				this.growTL.to( this.lavender1.scale, {
				z :1, 
				duration : 0 })
				this.lavender1.visible = false;
				this.lavender1.position.set(1000,0,0);
				this.lavender2.visible = true;
				this.lavender2.position.set(0,0,0);
				this.grow(this.lavender2, 1.2);

				break;
				
			case 3:
				this.wateringCanAnim();
				this.growTL.to( this.lavender2.scale, {
					z :1, 
					duration : 0 })
			this.lavender2.visible = false;
			this.lavender2.position.set(1000,0,0);
			this.lavender3.visible = true;
			this.lavender3.position.set(0,0,0);
				this.grow(this.lavender3, 1.2);
				this.world.editText("Lavender has been used for over 2500 years! That's before medieval times!");



				break;
				
			case 4:
				this.wateringCanAnim();
				this.growTL.to( this.lavender3.scale, {
					z :1, 
					duration : 0 })
			this.lavender3.visible = false;
			this.lavender3.position.set(1000,0,0);
			this.lavender4.visible = true;
			this.lavender4.position.set(0,0,0);
				this.grow(this.lavender4, 1.2);
				this.world.editText("Lavender has been used for over 2500 years! That's before medieval times!");



				break;
			case 5:
				this.world.editText("Bees like colourful flowers like lavender to collect it's pollen!");
				let bee = this.model.getObjectByName("Bee");
				
				bee.children[0].visible = true;
				bee.children[1].visible = true;
				bee.children[2].visible = true;
				bee.children[3].visible = true;
				bee.children[0].position.set(0,0,0);
				bee.children[1].position.set(0,0,0);
				bee.children[2].position.set(0,0,0);
				bee.children[3].position.set(0,0,0);
				this.project.changeMode = true;

				this.beeTL = gsap.timeline({repeat:-1});

				this.beeTL.to( bee.rotation, {
            		y : 8, 
            		duration : 5 
        		}, 0 );
		
        this.growTL.add( ()=>{

			this.stage++;
			this.lavenderGrow(this.stage);
        }, 4.5 );
				break;
		}
	}
	grow(objectRef, multiplier){
		this.growTL = gsap.timeline();

		this.growTL.to( objectRef.scale, {
            z :multiplier, 
            duration : 5 
        }, 0 );
		
        this.growTL.add( ()=>{
		
			this.stage++;
			this.lavenderGrow(this.stage);
        }, 4.5 );
	}
	CosmosGrow(stage){
		this.Cosmos1 = this.model.getObjectByName("Cosmos1");
		this.Cosmos2 = this.model.getObjectByName("Cosmos2");
		this.Cosmos3 = this.model.getObjectByName("Cosmos3");
		this.Cosmos4 = this.model.getObjectByName("Cosmos4");
		this.stage2 = stage;
		switch(this.stage2){
			case 1:
				this.wateringCanAnim();
				this.grow2(this.Cosmos1, .01);
				this.growTL.to( this.Cosmos4.scale, {
					z :0.008, 
					duration : 0 })

				break;
				
			case 2:
				
				this.wateringCanAnim();
				this.growTL.to( this.Cosmos1.scale, {
					z :0.008, 
					duration : 0 })
				this.Cosmos1.visible = false;
				this.Cosmos1.position.set(1000,0,0);
				this.Cosmos2.visible = true;
				this.Cosmos2.position.set(0,0,0);
				this.grow2(this.Cosmos2, .02);
			
				break;
				
			case 3:
				this.growTL.to( this.Cosmos2.scale, {
					z :0.008, 
					duration : 0 })
				this.wateringCanAnim();
				this.world.editText("Cosmoses are very easy to grow from seeds and dont need much to look after them!");

			this.Cosmos2.visible = false;
			this.Cosmos2.position.set(1000,0,0);
			this.Cosmos3.visible = true;
			this.Cosmos3.position.set(0,0,0);
				this.grow2(this.Cosmos3, .01);


				break;
				
			case 4:

				this.wateringCanAnim();
				this.world.editText("Cosmoses are very easy to grow from seeds and dont need much to look after them!");

				this.growTL.to( this.Cosmos3.scale, {
					z :0.008, 
					duration : 0 })
			this.Cosmos3.visible = false;
			this.Cosmos3.position.set(1000,0,0);
			this.Cosmos4.visible = true;
			this.Cosmos4.position.set(0,0,0);
				this.grow2(this.Cosmos4, .012);


				break;
			case 5:
				this.world.editText("Ladybugs are actually beetles! And they can live around 2-3 years!");
				let Ladybug = this.model.getObjectByName("Ladybug");
				Ladybug.visible =  true;
				Ladybug.position.set(0,0,0);
				this.project.changeMode = true;

				break;
		}
	}
	grow2(objectRef, multiplier){
		this.growTL = gsap.timeline();

		this.growTL.to( objectRef.scale, {
            z :multiplier, 
            duration : 5 
        }, 0 );
		
        this.growTL.add( ()=>{

			this.stage2++;
			this.CosmosGrow(this.stage2);
        }, 4.5 );
	}
	ButtonSelector(ID){
		for (let i = 0; i < this.sceneModels.length; i++)
		{
			switch(ID){
				case 1:
			if(this.sceneModels[i].name === "PineTree1")
			{
				this.sceneModels[i].visible = true;
				this.sceneModels[i].position.set(0,0,0);
				console.log("pine");
			}
			else{
				this.sceneModels[i].visible = false;
			this.sceneModels[i].position.set (1000,0,0);
			}
			break;
			case 2:
			if(this.sceneModels[i].name === "Lavender1")
			{
				this.sceneModels[i].visible = true;
				this.sceneModels[i].position.set (0,0,0);
				console.log("lavender");
			}
			else{
				this.sceneModels[i].visible = false;
			this.sceneModels[i].position.set (1000,0,0);
			}
			break;
			case 3:
			if(this.sceneModels[i].name === "Cosmos1")
			{
				this.sceneModels[i].visible = true;
				this.sceneModels[i].position.set (0,0,0);
				console.log("cosmos");
			}
			else{
				this.sceneModels[i].visible = false;
			this.sceneModels[i].position.set (1000,0,0);
			}
			break;
			}
		}
		
		
	}
	wateringCanAnim(){
		this.project.uiSoundEffect(this.project.Watering_audio);
		this.WateringCan = this.model.getObjectByName("Cone009")
		this.WateringCan.visible = true;
		this.WateringCan.position.set (0,0,0);
		this.TiltCanTL = gsap.timeline();
		this.TiltCanTL.to( this.WateringCan.rotation, {
            y :-.3, 
            duration : 1 
        }, 0 );
		this.TiltCanTL.add( ()=>{
			
		this.TiltCanTL.to( this.WateringCan.rotation, {
            y :+.3, 
            duration : 1 
        }, 1.1 );
			this.WateringCan.visible = false;

		}, 1.1 );
		this.world.editText("Plants need water to grow but be careful about giving them too much!");
	}

	argh(){

		if(this.largeTree === this.pineTree2){
			console.log('position.set')
			console.log(typeof this.largeTree.children[0].position.set)
		this.largeTree.children[0].visible = true;
		this.largeTree.children[0].position.set(0,0,0);
		this.largeTree.children[1].visible = true;
		this.largeTree.children[1].position.set(0,0,0);
		this.createTrees(this.pineTree2, this.pineTree3, 1.2, "Y");

	}
	else if(this.largeTree === this.pineTree3)
	{
		
		this.createTrees(this.pineTree3, this.pineTree4, .008, "Z");
		this.world.editText("A pine tree can grow as tall as 67 elephants stacked up!");

	}
	else if(this.largeTree === this.pineTree4)
	{
		this.growTL.to( this.pineTree3.scale, {
			z :0.006, 
			duration : 0 })
		this.createTrees(this.pineTree4, this.pineTree5, .005 ,"Z");
		this.world.editText("A pine tree can grow as tall as 67 elephants stacked up!");

	}
	
	else if(this.largeTree === this.pineTree5)
	{
		this.project.changeMode = true;

		this.model.getObjectByName("Squirrel").children[0].visible = true;
		this.model.getObjectByName("Squirrel").children[0].position.set(0,0,0);
		this.world.editText("Squirrels like pine trees! They have no where to live if we cut them all down :(");
		
		this.growTL.to( this.pineTree5.scale, {
			y :.6, 
			duration : 5 })
		this.growTL.to( this.pineTree1.scale, {
			y :1.5, 
			duration : 0 })
	}
	
	
	}

	placementMode( bool ) {
		if( bool ) {
			// Stuff to happen when in placement mode
			this.project.uiSoundEffect(this.project.Dig_audio);

		}
		else if( !bool ) {
			// Stuff to happen when not in placement mode
			this.project.uiSoundEffect(this.project.Dirt_audio);

		}
	}
	update() {
		if( this.hasAnimation ) {
			if( animationPaused ) return; // Stop the animation mixter from updating, which pauses the anaimtion
			this.animMixer.update( this.time.delta * 0.001 ); // update the animation mixer
		}
	}
}